<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">关于我们</div>
        <div class="item_small">-ABOUT US-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">COMPANY</div>
          <div class="primary_color_text">QUALFITY</div>
        </div>
        <div class="top_text_box_two">公司资质</div>
      </div>
      <div class="profile_content acea-row row-column row-center-wrapper">
            广东庞盛科技有限公司凭借对智能配电保护的专业技术和科学创新，成功获得国家发明、实用新型专利、外观专利共计十余项专利，拥有完全自主知识产权。
      </div>
      <div class="certificate_content row-column acea-row row-center-wrapper">
          <Certificate></Certificate>
      </div>
    </div>
  </div>
</template>
<script>
import Certificate from"@/components/aboutCompany/certificate"
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/about_company/profile/hader_bg.png"),
    };
  },
  components:{
      Certificate
  }
};
</script>
<style scoped>
.content_box {
  width: 100%;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .certificate_content{
    margin: 20px 0px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 4%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  font-weight: bolder;
  color: #7f7f7f;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}

/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/aboutCompany/qualifications.vue